import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { scrubBreadcrumb, scrubEvent } from 'app/core/utils/sentry-scrub';
import { runtimeEnv } from 'app/core/types/runtime-env';
import { shouldEnableSentry } from 'app/core/utils/sentry-enabled';
import { environment } from 'environments/environment';

Sentry.init({
  dsn: 'https://8e5bed53b9de6dcf99f2136cf1a2a5fc@sentry.fluxvane.com/3',
  // Without these tags every tier reported into project 3 as one stream, so a
  // spike could not be attributed to dev, uat or real users. The tag comes from
  // the per-tier environment file (Angular fileReplacements); infra can override
  // it, and supply a release, through the runtime `window.__env` block.
  environment:
    (runtimeEnv().sentryEnvironment as string) ||
    environment.sentryEnvironment,
  release: runtimeEnv().sentryRelease as string | undefined,
  // Errors only, matching the backend defaults in Nera.Lib: no performance
  // tracing sampling and no PII.
  sendDefaultPii: false,
  // Share codes and invite tokens are reusable credentials: keep them out of reports.
  beforeBreadcrumb: scrubBreadcrumb,
  // apiErrorInterceptor (neraApiErrorInterceptor, wrapped) toasts every API
  // failure and rethrows a `NeraApiError` carrying `{ status, message,
  // traceId, originalError }` — an HTTP 4xx already handled user-side is not a
  // Sentry event. Anything below 5xx that still escaped an error path (a bare
  // .subscribe() somewhere) is dropped here; 5xx still reports. `originalError`
  // is the discriminator the interceptor mints, so other Errors and 401s are
  // untouched.
  beforeSend: (event, hint) => {
    const original = hint.originalException as
      | { status?: unknown; originalError?: unknown }
      | undefined;
    if (
      original &&
      typeof original === 'object' &&
      'originalError' in original &&
      typeof original.status === 'number' &&
      original.status < 500
    ) {
      return null;
    }
    return scrubEvent(event);
  },
  enabled: shouldEnableSentry(environment.production, runtimeEnv()),
});
bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
